module.exports = __webpack_public_path__ + "static/media/20ECE4.34b1ec02.jpg";